import React, { useCallback, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Menu, MenuItem } from '@mui/material';
import { actions } from 'pages/PatientView/PatientView.redux';
import { useNavigate, useParams } from '@tanstack/react-router';
import DeletePopover from 'components/DeletePopover';

const PatientChartsCell = (params) => {
    const id = params.row.visit_id;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { patient_id } = useParams({ from: '/patients/view/$patient_id' });
    const actionAnchor = useRef(null);
    const [actionsOpen, setActionsOpen] = useState(false);
    const { field } = params;

    const handleCopyChart = useCallback(() => {
        setActionsOpen(false);
        dispatch(actions.addNewChart(patient_id, id, navigate));
    }, [dispatch, patient_id, id, navigate]);

    const beforeDeleteChart = useCallback(() => {
        dispatch(actions.setState({ chartsLoading: true }));
    }, [dispatch]);

    const afterDeleteChart = useCallback(() => {
        dispatch(actions.loadCharts(patient_id));
        setActionsOpen(false);
    }, [dispatch, patient_id]);

    const handleNavigate = useCallback(() => {
        navigate({ to: `/chart/${id}` });
    }, [navigate, id]);

    if (field === 'actions') {
        return (
            <>
                <Button
                    variant="outlined"
                    size="small"
                    onClick={(event) => {
                        event.stopPropagation();
                        setActionsOpen(true);
                    }}
                    ref={actionAnchor}
                >
                    ...
                </Button>
                <Menu open={actionsOpen} onClose={() => setActionsOpen(false)} anchorEl={actionAnchor.current}>
                    <MenuItem onClick={(event) => event.stopPropagation()}>
                        <Button variant="text" size="large" onClick={handleCopyChart}>
                            Copy Chart
                        </Button>
                    </MenuItem>
                    <MenuItem onClick={(event) => event.stopPropagation()}>
                        <DeletePopover
                            objectType="CHART"
                            objectID={id}
                            afterDelete={afterDeleteChart}
                            beforeDelete={beforeDeleteChart}
                        >
                            <Button variant="text" size="large" color="error">
                                Delete Chart
                            </Button>
                        </DeletePopover>
                    </MenuItem>
                </Menu>
            </>
        );
    }

    return <span onClick={handleNavigate}>{params.value ?? ''}</span>;
};

export default PatientChartsCell;
